import { Operator } from 'core-components/types'

export const DEFAULT_OPERATOR = Operator.CONTAINS
export const DEFAULT_FILTER_VALUE = ''
